import LaunchIcon from '@mui/icons-material/Launch';
import BoxWrapper from 'blocks/BoxWrapper';
import Button, { ButtonWrapper } from 'blocks/Button';
import { Row } from 'blocks/CommonLayout';
import { PageTitle } from 'blocks/Text';
import BadgeText from 'components/BadgeText';
import Table from 'components/Table';
import ROUTES from 'config/routes-constant';
import { getAlphabetDate } from 'helper/date';
import Paths from 'helper/paths';
import WithSidebar from 'layouts/WithSidebar';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ajax from 'utils/ajax';
import urls from 'utils/urls';
import { TicketInterfae, TicketResponse } from './ticket.interface';
import * as S from './ticket.styles';

const Tickets = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [tickets, setTickets] = useState<Array<TicketInterfae>>([]);
  const [pageData, setPageData] = useState({
    count: 0,
    totalPage: 0,
    page: 0,
  });

  useEffect(() => {
    getTickets(pageData.page);
  }, [pageData.page]);

  const getTickets = async (page: number) => {
    const res = await ajax<TicketResponse>({
      url: urls.tickets + `?page=${page}`,
      method: 'GET',
    });

    if (!res) return;

    setLoading(false);
    setTickets(res.data);
    setPageData({
      count: res.totalItems,
      totalPage: res.totalPages,
      page: res.currentPage,
    });
  };

  const getBadgeColor = (status: string) => {
    if (status === 'new') return 'success';
    if (status === 'closed') return 'error';
    return 'warn';
  };

  const next = () =>
    setPageData({
      ...pageData,
      page: pageData.page + 1,
    });

  const prev = () =>
    setPageData({
      ...pageData,
      page: pageData.page - 1,
    });

  return (
    <WithSidebar>
      <S.Wrapper>
        <BoxWrapper>
          <Row align="center" justify="space-between">
            <div>
              <PageTitle>{t('pages.tickets.list.title')}</PageTitle>
              <S.TicketHeadCount className="count">
                {t('pages.tickets.list.resultsCount', { count: pageData.count })}
              </S.TicketHeadCount>
            </div>

            <S.TicketHeadAction className="head-action">
              {/* <TextField
                                placeholder='Search'
                                // onClick={() => setOpenSearchModal(true)}
                                readonly
                            /> */}

              <S.TicketHeadButton as={ButtonWrapper} className="buttons">
                {/* <Button width={147}>Excel Export</Button> */}
                <Button width={147} type="link" href={ROUTES.createTicket}>
                  {t('pages.tickets.list.addNewTicketCTA')}
                </Button>
              </S.TicketHeadButton>
            </S.TicketHeadAction>
          </Row>
        </BoxWrapper>
        <BoxWrapper>
          <Table
            boxed
            name="tickets"
            loading={loading}
            head={[
              { text: t('pages.tickets.list.table.headers.subject') },
              { text: t('pages.tickets.list.table.headers.admin') },
              { text: t('pages.tickets.list.table.headers.date') },
              { text: t('pages.tickets.list.table.headers.status') },
              { text: t('pages.tickets.list.table.headers.action') },
            ]}
            rows={tickets.map((ticket) => [
              { content: ticket.subject },
              { content: ticket.adminId ? ticket.Admin?.fname + ' ' + ticket.Admin?.lname : '---' },
              { content: getAlphabetDate(ticket.createdAt) },
              {
                content: (
                  <S.Middle as={BadgeText} color={getBadgeColor(ticket.status)}>
                    {ticket.status}
                  </S.Middle>
                ),
                className: 'status-table',
              },
              {
                content: (
                  <S.Middle
                    as={Button}
                    iconStart={<LaunchIcon />}
                    type="link"
                    href={Paths.Tickets.single().route(ticket.id)}
                  >
                    {t('pages.tickets.list.table.showDetailsCTA')}
                  </S.Middle>
                ),
                className: 'action-table',
              },
            ])}
            page={pageData.page}
            total={pageData.count}
            next={next}
            prev={prev}
          />
        </BoxWrapper>
      </S.Wrapper>
    </WithSidebar>
  );
};

export default Tickets;
